export var isValidUrl = function (string) {
    try {
        new URL(string);
        return true;
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=isValidUrl.js.mapexport var isValidUrl = function (string) {
    try {
        new URL(string);
        return true;
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=isValidUrl.js.map